import { apiPath } from 'constants/api';

import type { ApiPathMatcher, ApiPathId } from 'constants/api';

import type { CommonError, InlineError, PopupError, RedirectError } from './types';

export const isError = (error: CommonError | null): error is CommonError => {
  return !!error;
};

function isDynamicMatcher(matcher: ApiPathMatcher): matcher is Extract<
  ApiPathMatcher,
  {
    pathname: (...args: (string | number)[]) => string;
  }
> {
  return typeof matcher.pathname === 'function';
}

export function matchesPath(path: string, matcher: ApiPathMatcher): boolean {
  if (isDynamicMatcher(matcher)) {
    return matcher.regexp.test(path);
  } else {
    return path.endsWith(matcher.pathname);
  }
}

export function getMatchingPath(path: string | undefined): ApiPathId | undefined {
  if (!path) return undefined;

  for (const key in apiPath) {
    if (apiPath.hasOwnProperty(key)) {
      const matcher = apiPath[key];

      if (matchesPath(path, matcher)) {
        return matcher.id;
      }
    }
  }

  return undefined;
}

type ErrorTypeMap = {
  popup: PopupError;
  inline: InlineError;
  redirect: RedirectError;
};

export function isErrorType<K extends keyof ErrorTypeMap>(
  error: CommonError,
  type: K,
): error is ErrorTypeMap[K] {
  return error.type === type;
}
